import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  DesignProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getBorderRadiusOptions,
  getObjectFitOptions,
  getObjectPositionOptions,
  getVideoOpacityOptions,
} from "@circle-react-shared/BuilderUI/utils/videoStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "video",
  props: {
    videoUpload: {
      prop: "other",
      type: "circle-video-upload",
      value: {
        source: "upload",
        signed_id: "",
        html: "",
        hasCustomCoverImage: false,
        customCoverImage: {
          signed_id: "",
        },
        isVideoMuted: false,
        isVideoLooped: false,
        hasAltText: false,
        videoAltText: "",
      },
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        objectFit: getObjectFitOptions({
          defaultValue: defaultStyles.objectFit,
        }),
        objectPosition: getObjectPositionOptions({
          defaultValue: defaultStyles.objectPosition,
        }),
        opacity: getVideoOpacityOptions({
          defaultValue: defaultStyles.opacity,
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: defaultStyles.borderRadius,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        }),
        sizing: getSizingOptions({
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        }),
      },
    },
  },
};
